import * as React from 'react';
import Datatable from '../../DataTable';
import { userTableColumns, userTableOptions } from './config';
import ReactDOM from 'react-dom';
import { UserInfo } from '../../Login/common/defaults';

interface UserListUIStateProps {
	users: UserInfo[];
}

interface IUserListUIActions {
	selectUserToEdit: (cellData) => void;
}

export interface IUserListUIProps extends UserListUIStateProps, IUserListUIActions {}

const UserListUI: React.FC<IUserListUIProps> = ({ users, selectUserToEdit }) => {
	const userTablecolumnDefs = [
		{
			targets: 0,
			orderable: false,
			createdCell: (td, cellData) => {
				return ReactDOM.render(
					<i
						className="fas fa-edit pointer"
						data-id={cellData}
						onClick={() => {
							selectUserToEdit(cellData);
						}}
					/>,
					td
				);
			}
		}
	];

	return (
		<Datatable
			id="tblUserAdministration"
			columns={userTableColumns}
			{...userTableOptions}
			data={users}
			columnDefs={userTablecolumnDefs}
		/>
	);
};

export default UserListUI;
